import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';
import { useCallback } from 'react';
import { useMarketRoute } from '../../../../../hooks/useMarketRoute';
import { useMarketDetail } from '../../../queries/useMarketDetail';

export const useLogClickShare = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  const { params } = useMarketRoute();

  const { data: marketDetail } = useMarketDetail(params.marketId);

  return useCallback(() => {
    if (!marketDetail) return;

    logMarketAnalytics({
      name: 'CLICK_SHARE_MARKET',
      analytics: {
        IS_FAVORITE: marketDetail.market.favorite !== null ? '1' : '0',
      },
    });
  }, [logMarketAnalytics, marketDetail]);
};
